/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./guidePage.vue?vue&type=template&id=0bd6ce20&scoped=true&"
import script from "./guidePage.vue?vue&type=script&lang=js&"
export * from "./guidePage.vue?vue&type=script&lang=js&"
import style0 from "./guidePage.vue?vue&type=style&index=0&id=0bd6ce20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd6ce20",
  null
  
)

export default component.exports